import dayjs from "dayjs";
import styled from "styled-components";

import "dayjs/locale/ja";
import NoticeLabel from "components/NoticeLabel";
import color from "constants/color";
import font from "constants/font";

dayjs.locale("ja");

const DurationContent = styled.div`
  display: flex;
  flex: 0;
  padding-top: 4px;
`;
const DurationValue = styled.div`
  margin: 16px;
  font-size: ${font.size16};
  -webkit-text-stroke: 0.6px black;
`;
const LabelWrap = styled.div`
  width: 421px;
`;

const getWeekday = (date: dayjs.Dayjs) => {
  const weekdays = ["日", "月", "火", "水", "木", "金", "土"];
  return weekdays[date.day()];
};

const DurationDisplay = ({ startAt, endAt }: { startAt: string; endAt: string }) => {
  const start = dayjs(startAt);
  const end = dayjs(endAt);

  const durationText = `${start.format(`YYYY年M月D日`)}（${getWeekday(start)}）${start.format("HH:mm")} ～ ${end.format(`M月D日`)}（${getWeekday(end)}）${end.format("H:mm")}`;

  return (
    <DurationContent>
      <LabelWrap>
        <NoticeLabel backgroundColor={color.attentionLight}>
          <DurationValue>{durationText}</DurationValue>
        </NoticeLabel>
      </LabelWrap>
    </DurationContent>
  );
};

export default DurationDisplay;
